import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="relative w-full max-w-xs mx-auto aspect-[3/4] rounded-2xl overflow-hidden shadow-sm">
                <img
                  src={appData.image}
                  alt="春色影视移动端"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
                {appData.title}
              </h2>
              <p className="text-lg text-primary-500 font-bold mb-4">{appData.subtitle}</p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                {appData.description}
              </p>

              <div className="grid grid-cols-2 gap-3 mb-6 max-w-sm mx-auto lg:mx-0">
                {appData.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                    <span className="whitespace-nowrap">{feature}</span>
                  </div>
                ))}
              </div>

              <button className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-base rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-smartphone-line text-lg"></i>
                了解更多
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}